import { DropzoneProtected } from '@components'

import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useUploadBillAttachments } from '@features/bills/hooks/useUploadBillAttachments'

import { Scope } from '../../../../enums/scope'
import { TrackingContext } from '../../../../enums/trackingContext'
import { useBillView } from '../BillReadableForm'

interface BillReadableAttachmentsDropzoneProps {
  isUploading?: boolean
  onUploadFinished?: () => void
  onUploadStart?: () => void
}

export const BillReadableAttachmentsDropzone = ({
  isUploading,
  onUploadFinished,
  onUploadStart,
}: BillReadableAttachmentsDropzoneProps): ReactElement => {
  const { t } = useTranslation()
  const { billData } = useBillView()
  const billId = billData?.bill?.id

  const { handleFilesDropped } = useUploadBillAttachments({ billId, onUploadStart, onUploadFinished })

  return (
    <DropzoneProtected
      contentText={t('bill.view.bill_attachments_dropzone.placeholder')}
      scopes={Scope.BillAttachmentWrite}
      onDrop={handleFilesDropped}
      isUploading={isUploading}
      trackingContext={TrackingContext.BillUpload}
    />
  )
}
